<template>
  <div class="searchfilters">
    <Collapse
      :id="'searchfilters-collapse'"
      :open="!isDesktopView"
      :showOnlyContent="isDesktopView"
    >
      <template #button-content-before-icon>
        <text id="searchfilters-collapse-rubrik">{{ texts.sokInom }}</text>
      </template>
      <template #collapse-content>
        <fieldset>
          <legend class="visually-hidden">{{ texts.sokInom }}</legend>
          <ul>
            <li v-for="filter in sokFilter" :key="filter.type">
              <label :class="['filter', { active: filter.type === selected }]">
                <input
                  type="radio"
                  :id="filter.type"
                  :value="filter.type"
                  :checked="filter.type === selected"
                  name="filter"
                  @change="updateSelected(filter.type)"
                  @click="(event) => onClick(event, filter.type)"
                />
                <span>{{ filter.text }}</span>
              </label>
            </li>
          </ul>
        </fieldset>
      </template>
    </Collapse>
  </div>
</template>
<script>
import Collapse from "../../bootstrap/collapse.vue";

export default {
  name: "SearchFilters",
  props: {
    selectedFilter: String,
    texts: Object,
    sokFilter: Array,
  },
  data: function () {
    return {
      isDesktopView: true,
      selected: "",
      breakpoint: parseInt(
        getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-xl")
      ),
    };
  },
  components: {
    Collapse,
  },
  created() {
    this.selected = this.selectedFilter;
    this.IsDesktop();
  },
  mounted() {
    window.addEventListener("resize", this.IsDesktop);
  },
  unmounted() {
    window.removeEventListener("resize", this.IsDesktop);
  },
  methods: {
    updateSelected(selected) {
      this.selected = selected;
    },
    onClick(event, selected) {
      if (event.x != 0 || event.y != 0) {
        this.updateSelected(selected);
        this.$emit("filterSelected", selected);
      }
    },
    IsDesktop() {
      this.isDesktopView = window.innerWidth >= this.breakpoint;
    },
  },
};
</script>
